module.exports = __webpack_public_path__ + "img/template6.e3cfbb1d.png";